<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :excluded-filter-fields="excludeFilterFields"
                       :headers="headers"
                       multi-sort
                       data-url="hkiarace/admin/operator/"
                       data-key="operators"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template #item.account.type="{value}">
      {{
        {
          100: $t('account_type.operator'),
          369: $t('account_type.admin'),
        }[value]
      }}
    </template>
    <template #item.account.disabled="{value}">
      <v-icon v-if="value">mdi-lock</v-icon>
    </template>
    <template #item.locked_until="{item}">
      <v-row>
        <v-col>
          <font-awesome-icon icon="lock" v-if="operatorLocked(item)"
                             @click.stop="unlockOperator(item)"></font-awesome-icon>
        </v-col>
      </v-row>
    </template>
    <template #item.actions="{item}">
      <v-row>
<!--        <v-col>-->
<!--          <font-awesome-icon icon="edit"-->
<!--                             @click.stop="editItem(item)"></font-awesome-icon>-->
<!--        </v-col>-->


        <v-col>
          <v-tooltip top>
            <template #activator="{on, attrs}">
              <v-btn icon
                     v-on="on"
                     v-bind="attrs"
                     @click="editItem(item)">
                <v-icon>mdi-square-edit-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('edit') }}</span>
          </v-tooltip>
          <!--          <font-awesome-icon icon="edit"-->
          <!--                             @click="editItem(item)"></font-awesome-icon>-->
        </v-col>
        <v-col v-if="!item.account.disabled">
          <v-tooltip top>
            <template #activator="{on, attrs}">
              <v-btn icon
                     v-on="on"
                     v-bind="attrs"
                     @click="disableOperator(item)">
                <v-icon>mdi-lock</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('disable') }}</span>
          </v-tooltip>
          <!--          <font-awesome-icon icon="lock"-->
          <!--                             @click="disableItem(item)"></font-awesome-icon>-->
        </v-col>
        <v-col v-if="item.account.disabled">
          <v-tooltip top>
            <template #activator="{on, attrs}">
              <v-btn icon
                     v-on="on"
                     v-bind="attrs"
                     @click="enableOperator(item)">
                <v-icon>mdi-lock-open</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('enable') }}</span>
          </v-tooltip>
          <!--          <font-awesome-icon icon="unlock"-->
          <!--                             @click="enableItem(item)"></font-awesome-icon>-->
        </v-col>


<!--        <v-col v-if="!item.account.disabled">-->
<!--          <font-awesome-icon icon="user-times"-->
<!--                             @click.stop="disableOperator(item)"></font-awesome-icon>-->
<!--        </v-col>-->
<!--        <v-col v-if="item.account.disabled">-->
<!--          <font-awesome-icon icon="user-check"-->
<!--                             @click.stop="enableOperator(item)"></font-awesome-icon>-->
<!--        </v-col>-->
      </v-row>
    </template>
  </RemotePaginatedList>
</template>

<script>

import RemotePaginatedList from "@/components/RemotePaginatedList";
import {computed, onMounted, ref, watch} from "@vue/composition-api";
import {DateTime} from "luxon";

export default {
  name: 'OperatorList',
  components: {RemotePaginatedList},
  props: {
    hideSearch: Boolean,
    showSelect: Boolean,
    excludeFilterFields: Array,
    refreshTrigger: Boolean,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    });

    // Filter
    const filterOptions = computed(() => {
      return [
        {text: root.$t('admin_operator.email'), value: 'account.email', contains: true},
        {
          text: root.$t('admin_operator.user_type'), value: 'account.type',
          options: [
            {text: root.$t('account_type.operator'), value: 100},
            {text: root.$t('account_type.admin'), value: 369},
          ]
        },
        {
          text: root.$t('admin_operator.disabled'), value: 'account.disabled',
          options: [
            {text: root.$t('yes'), value: true},
            {text: root.$t('no'), value: false},
          ]
        },
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('admin_operator.email'), value: 'account.email'},
      {text: root.$t('admin_operator.user_type'), value: 'account.type', sortable: false},
      {text: root.$t('admin_operator.disabled'), value: 'account.disabled'},

      {text: '', value: 'actions', sortable: false, width: 200},
    ]);
    const innerRefreshTrigger = ref(false);

    const operatorLocked = function (operator) {
      return operator.locked_until && DateTime.fromISO(operator.locked_until) > new Date();
    };
    const unlockOperator = function (item) {
      if (confirm(root.$t('admin_operator.confirm_unlock_msg'))) {
        root.$callAPI('hkiarace/admin/operator/unlock/', {id: item.id}, function () {
          refresh();
        })
      }
    };
    const editItem = function (item) {
      emit('edit', item);
    };
    const disableOperator = function (item) {
      root.$callAPI('hkiarace/admin/operator/disable/', {id: item.account.id}, function () {
        refresh();
      });
    }
    const enableOperator = function (item) {
      root.$callAPI('hkiarace/admin/operator/enable/', {id: item.account.id}, function () {
        refresh();
      });
    }


    return {
      filterOptions,
      headers,
      innerRefreshTrigger,

      operatorLocked,
      unlockOperator,
      editItem,
      disableOperator,
      enableOperator,
    }
  },
}
</script>
